export const ns = {
  wrapper: "sticky top-0 z-[1000] w-full",
  nav: "w-full lg:w-4/5 mx-auto bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100 px-6 lg:px-24 py-2 flex justify-between items-center rounded-none lg:rounded-b-[32px]",
  logo: "h-12 lg:h-16 w-auto object-contain cursor-pointer transition-opacity hover:opacity-80",
  
  menuContainer: "hidden lg:flex items-center gap-10",
  navBtn: (isActive) => `
    text-[11px] font-black uppercase tracking-[0.15em] transition-colors duration-300 relative py-2
    ${isActive ? 'text-[#00704a]' : 'text-slate-400 hover:text-slate-800'}
  `,
  activeIndicator: "absolute bottom-0 left-0 w-full h-0.5 bg-[#00704a] rounded-full",
  
  mobileMenuBtn: "lg:hidden p-2 text-slate-600",
  mobileDropdown: "absolute top-full left-0 w-full bg-white border-b border-gray-100 shadow-xl flex flex-col p-6 gap-4 lg:hidden",
  mobileNavBtn: (isActive) => `
    text-[12px] font-black uppercase tracking-[0.15em] py-3 border-b border-gray-50 text-left
    ${isActive ? 'text-[#00704a]' : 'text-slate-500'}
  `,
  
  logoutContainer: "flex items-center lg:border-l lg:border-gray-100 lg:pl-8 lg:ml-4",
  logoutBtn: "group flex items-center gap-3",
  logoutText: "hidden sm:block text-[10px] font-black text-red-500/70 group-hover:text-red-600 uppercase tracking-widest",
  logoutIconBox: "p-2 bg-red-50 rounded-xl group-hover:bg-red-500 group-hover:text-white text-red-500 transition-all duration-300 shadow-sm"
};